import React, { useState, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import "../../styles/csv_upload.css";
import label from "../../postExaminationProcessObjective/labels/postExaminationProcessObjective_en.json";
import commonLabels from "../../common/labels/common_en.json";
import { toastr } from 'react-redux-toastr';

import {
    getExamslistByAdvertisementId
} from "../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";

import { uploadPhysicalTestMarks } from "../actions/testsActions";

import { downloadSampleCSVFile, getMainsAdvertisements } from "../../common/actions/commonActions";
import { useRef } from 'react';
import { fi } from 'date-fns/locale';

const ImportPhysicalTestMarks = (props) => {
    const { register, errors, reset } = useForm({
        mode: "onChange"
    });

    let [file, setFile] = useState("");
    const [marks, setMarks] = useState('');

    const dispatch = useDispatch();
    let { examList, subjectList, supervisorListById } = useSelector(
        (state) => state.postExamProcessObjectReducer,
        shallowEqual
    );

    let { yearList, getMainsAdvertisement } = useSelector(
        (state) => state.common,
        shallowEqual
    );
    const fileInputRef = useRef(null);

    const [reloadItem, setReloadItem] = useState(0);
    const [csvErr, setCsvErr] = useState("");
    const [saveButtonFlag, setSaveButtonFlag] = useState(false);
    const [uploadState, setUploadState] = useState(false);
    const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
    const [selectedExam, setSelectedExam] = useState("");

    const session = JSON.parse(sessionStorage.getItem("session"));

    useEffect(() => {

    }, [reloadItem]);

    useEffect(() => {
        if (selectedExam !== "" && file !== "") {
            setUploadState(false);
        } else {
            setUploadState(true);
        }
    }, [selectedExam, file]);

    const onAdvertisementChange = (ele) => {
        let selectedValue = ele;
        setSelectedAdvertNo(selectedValue);
        examList.length = 0;
        setSelectedExam("");
        setFile("");
        setSaveButtonFlag(true);
        selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
        setReloadItem(!reloadItem);
    };

    const onExamChange = (ele) => {
        let selectedValue = ele;
        setSelectedExam(selectedValue);
        setFile("");
        setSaveButtonFlag(false);
        setReloadItem(!reloadItem);
    };

    const onChangeImage = (event) => {
        setCsvErr("");
        if (event.target.files.length == 0) {
            return
        }
        setFile(event.target.files[0]);
    }

    const handleSampleDownload = () => {
        dispatch(downloadSampleCSVFile("physicalTest"))
    }

    const uploadFile = () => {
        let data = {};
        data.file = file;
        data.action = 'upload';
        if (data.file !== "") {
            setCsvErr("");
            dispatch(uploadPhysicalTestMarks(data, selectedExam, cancelModal, props.onCancelButton, marks, setUploadState));
            setSaveButtonFlag(true);
            setFile("");
            reset();
        } else {
            setCsvErr("This field is required");
        }
    }

    const cancelModal = () => {
        // dispatch(resetVenueErrorList());
        props.setShowImportMarks(false);
        setSaveButtonFlag(false);
        setFile("");
        setCsvErr("");
        setMarks("");
        reset();
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        props.onCancelButton();
    }

    const handleInputClick = () => {
        if (file !== "") {
            setSaveButtonFlag(true)
        }
    }

    const onSelectYear = (ele) => {
        let selectedValue = ele;
        selectedValue && dispatch(getMainsAdvertisements(selectedValue));
        if (getMainsAdvertisement) {
            getMainsAdvertisement.length = 0
        }
        if (examList) {
            examList.length = 0;
        }
        setCsvErr("");
        setFile("");
        reset();
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        setSaveButtonFlag(true);

        setReloadItem(!reloadItem);
    };

    const handleChange = (event) => {
        setMarks(event.target.value);
    };

    return (
        <div>

            <Modal size="xl" show={props.showImportMarks} onHide={cancelModal} aria-labelledby="example-modal-sizes-title-lg" backdrop='static' >
                <Modal.Header closeButton>
                    <Modal.Title>{commonLabels.ImportPhysicalTestMarks}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {/* <ul className="nav nav-tabs" role="tablist"> */}
                        <div className="row">
                            <div className="form-group col-md-2">
                                <label className="float-left">
                                    {commonLabels.selectYear}
                                    <span className="errorText">*</span>
                                </label>
                                <select
                                    className="form-control"
                                    name="selectedYear"
                                    ref={register({ required: true })}
                                    onChange={(e) => {
                                        onSelectYear(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">
                                        {commonLabels.COMBO_SELECT}
                                    </option>
                                    {yearList &&
                                        yearList.length > 0 &&
                                        yearList
                                            .map((element, index) => (
                                                <option key={index}>{element}</option>
                                                // <option key={index} value={element.id}>
                                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                // </option>
                                            ))}
                                </select>
                                {_.get("selectedYear.type", errors) ===
                                    "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                            </div>
                            <div className="form-group col-md-4">
                                <label className="float-left">
                                    {commonLabels.SelectAdvertNo}
                                    <span className="errorText">*</span>
                                </label>
                                <select
                                    className="form-control"
                                    name="selectedAdvertiseNo"
                                    ref={register({ required: true })}
                                    onChange={(e) => {
                                        onAdvertisementChange(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">
                                        {commonLabels.COMBO_SELECT}
                                    </option>
                                    {getMainsAdvertisement &&
                                        getMainsAdvertisement.length > 0 &&
                                        getMainsAdvertisement
                                            .filter(
                                                (element) =>
                                                    element.isDeleted == false &&
                                                    element.isActive === true
                                            )
                                            .map((element, index) => (
                                                <option key={index} value={element.id}>
                                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                </option>
                                            ))}
                                </select>
                                {_.get("selectedAdvertiseNo.type", errors) ===
                                    "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                            </div>

                            <div className=" col-md-3">
                                <label className="float-left">
                                    {label.SelectExam}
                                    <span className="errorText">*</span>
                                </label>
                                <select
                                    className="form-control"
                                    name="selectedExam"
                                    ref={register({ required: true })}
                                    onChange={(e) => {
                                        onExamChange(e.target.value);
                                    }}
                                >
                                    <option key={0} value="" >
                                        {commonLabels.COMBO_SELECT}
                                    </option>
                                    {
                                        examList &&
                                        examList.length > 0 &&
                                        examList
                                            .filter(
                                                (element) =>
                                                    element.isDeleted == false &&
                                                    element.isActive === true
                                            )
                                            .map((element, index) => (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            ))
                                    }
                                </select>
                                {_.get("selectedExam.type", errors) === "required" && (
                                    <p className="errorText float-left">
                                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>
                            <div className="form-group col-md-3">
                                <label className="float-left">
                                    {commonLabels.EnterMarks}
                                    <span className="errorText">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="marks"
                                    className="form-control"
                                    placeholder="Enter minimum marks for qualifying"
                                    pattern="^(99|\d{1,2}(?:\.\d{1,2})?)$"
                                    onChange={handleChange}
                                    value={marks}
                                    onKeyPress={(event) => {
                                        const input = event.target.value;
                                        if (!/[0-9]/.test(event.key) || input.length >= 3) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                                {_.get("marks.type", errors) === "required" && (
                                    <p className="errorText float-left">
                                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>
                        </div>
                        {/* <div className="row"> */}
                        <div className="d-flex align-items-center">
                            <div>
                                <input name="fileInput" type="file" accept={".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"} onChange={(event) => onChangeImage(event)} onClick={handleInputClick} ref={(e) => { register({ required: true })(e); fileInputRef.current = e; }} />
                                {csvErr !== "" && <p className="errorText">{csvErr}</p>}
                            </div>
                            <button type="button" onClick={uploadFile} className=" btn btn-primary btn-sm upload-btn-custom" disabled={uploadState}>
                                {commonLabels.Upload}
                            </button>
                            <div className="float-right">
                                <i
                                    className={"fa fa-file-excel-o ml-2 fa-2x text-success icon-pointer"}
                                    aria-hidden="true"
                                    onClick={() =>
                                        handleSampleDownload()
                                    }
                                    title='Donwload Sample Template'
                                ></i>
                            </div>
                        </div>
                        {/* </div> */}
                        {/* </ul> */}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={cancelModal} > {commonLabels.BUTTON_CANCEL}</button>
                </Modal.Footer>

            </Modal>

        </div>
    )
}
export default ImportPhysicalTestMarks;